import React from 'react'
import { Result, Button } from 'antd';
import { BrowserRouter as Router, useHistory, Link } from "react-router-dom";
export const Confirm = () => {
  return (
    <div className='confirm-wrap'>
        <Result
        status="success"
        title="Your email is confirmed!"
        extra={[
            <Link to="/Dashboard">
              <button className="btn btn-border"> + Create Book</button>
           </Link>,
        ]}
  />
     
    </div>
  )
}
